import { Button, Col, Form, Input, Modal, Row, Select, Space, Checkbox, InputNumber } from 'antd';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../../../api';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface Props {
  open: boolean;
  edit?: any;
  onClose: () => void;
  onSuccess: () => void;
  statusList: any[];
}
export const ShipmentStatusAddEdit = ({ open, onClose, onSuccess, statusList, edit }: Props) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (open) {
      if (edit) {
        form.setFieldsValue({
          cd: edit.cd,
          no: edit.no,
          name: edit.name,
          scanName: edit.scanName,
          menu: edit.menu,
          orders: edit.orders,
          canScan: edit.canScan,
          description: edit.description,
          descriptionEn: edit.descriptionEn,
          nextStatus: {
            PICKUP: edit.nextStatus?.PICKUP || [],
            HOMEDELIVERY: edit.nextStatus?.HOMEDELIVERY || [],
          },
          shipmentStatusReasons: (edit.shipmentStatusReasons || []).map((item: any) => {
            const itm = item;
            delete itm.status;
            delete itm.createdAt;
            delete itm.updatedAt;
            return itm;
          }),
          reasonRequired: edit.reasonRequired,
          complete: edit.complete,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, edit]);
  const onFinish = async (values: any) => {
    console.log(values);
    try {
      let response = null;
      if (edit) {
        response = await API.post({ apiVersion: 'api' })(
          `/settings/shipment_status/update`,
          values
        );
      } else {
        response = await API.post({ apiVersion: 'api' })(
          '/settings/shipment_status/create',
          values
        );
      }
      onSuccess();
    } catch (error: any) {
      console.error(error);
    }
  };
  return (
    <Modal
      okText="Хадгалах"
      cancelText="Болих"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      title="Хүргэлтийн төлөв нэмэх"
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item name="no">
          <Input type="hidden" />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="cd" label="Code" rules={[{ required: true, message: 'Code' }]}>
              <Input placeholder="Code" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Төлөвийн нэр"
              rules={[{ required: true, message: 'Төлөвийн нэр оруулна уу' }]}
            >
              <Input placeholder="Төлөвийн нэр" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="scanName"
              label="Скан нэр"
              rules={[{ required: true, message: 'Скан нэр оруулна уу' }]}
            >
              <Input placeholder="Скан нэр" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="orders"
              label="Меню эрэмбэ"
              rules={[{ required: true, message: 'Меню эрэмбэ оруулна уу?' }]}
            >
              <InputNumber style={{ width: '100%' }} placeholder="Меню эрэмбэ оруулна уу?" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="description"
              label="Төлөвийн тайлбар(%b-Салбарын нэр, %r-Шалтгаан)"
              rules={[{ required: true, message: 'Төлөвийн тайлбар' }]}
            >
              <Input placeholder="Төлөвийн тайлбар" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="descriptionEn"
              label="Төлөвийн тайлбар english"
              rules={[{ required: true, message: 'Төлөвийн тайлбар english' }]}
            >
              <Input placeholder="Төлөвийн тайлбар english" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="reasonRequired" valuePropName="checked">
              <Checkbox>Шалтгаан шаардлагатай эсэх</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="complete" valuePropName="checked">
              <Checkbox>Is Complete</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="canScan" valuePropName="checked">
              <Checkbox>Can Scan</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="menu" valuePropName="checked">
              <Checkbox>Хүргэлтэд харагдах</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.List name="shipmentStatusReasons">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item
                        {...restField}
                        name={[name, 'cd']}
                        rules={[{ required: true, message: 'Missing cd' }]}
                      >
                        <Input placeholder="Cd" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'name']}
                        rules={[{ required: true, message: 'Missing name' }]}
                      >
                        <Input placeholder="Name" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'description']}
                        rules={[{ required: true, message: 'Missing description' }]}
                      >
                        <Input placeholder="Description" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'descriptionEn']}
                        rules={[{ required: true, message: 'Missing descriptionEn' }]}
                      >
                        <Input placeholder="Description EN" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Шалтгаан нэмэх
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
          <Col span={24}>
            <Form.Item
              name={['nextStatus', 'PICKUP']}
              label="Дараагийн төлөв салбараас авах"
              rules={[{ required: false, message: 'Төлөвийн тайлбар english' }]}
            >
              <Select mode="multiple">
                {statusList.map((item: any) => (
                  <Select.Option key={item.cd} value={item.cd}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={['nextStatus', 'HOMEDELIVERY']}
              label="Дараагийн төлөв гараас гарт"
              rules={[{ required: false, message: 'Төлөвийн тайлбар english' }]}
            >
              <Select mode="multiple">
                {statusList.map((item: any) => (
                  <Select.Option key={item.cd} value={item.cd}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={['nextStatus', 'LOCKER']}
              label="Дараагийн төлөв локерт үлдээх"
              rules={[{ required: false, message: 'Төлөвийн тайлбар english' }]}
            >
              <Select mode="multiple">
                {statusList.map((item: any) => (
                  <Select.Option key={item.cd} value={item.cd}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
